module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3MjQuMzc1IiBoZWlnaHQ9IjMiIHZpZXdCb3g9IjAgMCA3MjQuMzc1IDMiPjxkZWZzPjxzdHlsZT4uYXtmaWxsOm5vbmU7c3Ryb2tlOiNmZjc2ODk7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLXdpZHRoOjNweDtzdHJva2UtZGFzaGFycmF5OjQgNzt9PC9zdHlsZT48L2RlZnM+PGxpbmUgY2xhc3M9ImEiIHgyPSI3MjEuMzc1IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjUgMS41KSIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/pink_line.svg
// module id = owDr
// module chunks = 0